import { render, staticRenderFns } from "./ClinicalTrialModal.vue?vue&type=template&id=6b5b597c&scoped=true"
import script from "./ClinicalTrialModal.vue?vue&type=script&lang=js"
export * from "./ClinicalTrialModal.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ClinicalTrialModal.vue?vue&type=style&index=1&id=6b5b597c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5b597c",
  null
  
)

export default component.exports